module.exports = __webpack_public_path__ + "static/media/tz.d33394f2.svg";